var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"left","padding":"8px","font-size":"24px"}},_vm._l((_vm.emojiList),function(e,i){return _c('span',{on:{"click":function($event){return _vm.selectEmoji(e)}}},[_vm._v(_vm._s(e))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }